import { createSelector } from '@reduxjs/toolkit';
import { memoize } from 'lodash';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  investmentStrategyAssetAllocationsAllIds,
  investmentStrategyAssetAllocationsById,
  investmentStrategyAssetAllocationsSelector,
  investmentStrategyAssetAllocationsMetadataSelector,
] = resourceSelectors('investmentStrategyAssetAllocations');

// One selector per id: a new one per call returns a new array on every render, which loops any
// effect that depends on it.
export const investmentStrategyAssetAllocationsByStrategyIdSelector = memoize(
  (id) =>
    createSelector(investmentStrategyAssetAllocationsSelector, (assetClasses) =>
      assetClasses.filter(
        (assetClass) => assetClass.investmentStrategy.id === id
      )
    )
);

export const investmentStrategyAssetAllocationsMetadataByIdSelector = (id) =>
  createSelector(
    investmentStrategyAssetAllocationsMetadataSelector,
    (meta) => meta[id]
  );
